export enum KeywordHelperType {
	WRONG_PORTAL = 'wrongPortal',
	BE_MORE_SPECIFIC = 'beMoreSpecific',
	ENGLISH_COURSE = 'englishCourse',
}
